// src/App.js
import React from 'react';
import './App.css';
import AppRouter from './components/AppRouter';

function App() {
  return (
    <div className="App bg-base-200">
      <AppRouter />
    </div>
  );
}

export default App;
